import ProductService from "~/service/productService";

export default {
  methods: {
    async handleProductRefresh({ productId, slug }) {
      try {
        const updatedProduct = await ProductService.getProductBySlug(slug, {
          _t: Date.now() // Cache bypass
        });

        if (updatedProduct) {
          const index = this.products.findIndex(p => p.productId === productId);
          if (index !== -1) {
            // Check if products is a prop (component receives it from parent)
            const isProductsProp =
              this.$options.props && this.$options.props.products;

            if (isProductsProp) {
              // Emit to parent to update the products array
              this.$emit("product-updated", { index, product: updatedProduct });
            } else {
              // Direct update for components that own their products array
              this.$set(this.products, index, updatedProduct);
            }
          }
        }
      } catch (err) {
        console.error("Error refreshing product:", err);
      }
    }
  }
};
